export const MAX_BUTTONS_DESKTOP = 9;
export const MAX_BUTTONS_MOBILE = 4;

export const PREVIOUS_PAGE = 'Previous Page';
export const NEXT_PAGE = 'Next Page';
export const ELLIPSES = '...';

function replaceUrlParam(url, newValue, paramName='page') {
	const urlObject = url && url.length && new URL(url);
	const hasParam = urlObject && urlObject.searchParams.has(paramName);

	if (hasParam) {
		// eslint-disable-next-line eqeqeq
		if (newValue == '1') urlObject.searchParams.delete(paramName);
		else urlObject.searchParams.set(paramName, newValue);
		
		return urlObject.toString();
	} 
	return url;
}

/* Generates an array of button labels corresponding to the page numbers.
        Sets the 1st element to page number 1, and the last element to the final page number.
        If not consecutive, sets the ellipses at position 2 and last-but-one. 
        Also adds the chevrons at the start and end positons. */
export function generateButtonArray({currentPage, maxPages, maxButtons, isMobile, seoUrl=''}) {
	const isSeoUrl =  seoUrl && seoUrl.length;
	const separator = isSeoUrl && seoUrl.includes('?') ? '&' : '?';
	const url = isSeoUrl && `${seoUrl}${separator}page`;

	const buttons = [{label: `${currentPage}`, href: replaceUrlParam(url, currentPage)}];

	/* eslint-disable-next-line no-plusplus */
	for (let i = 0; i < maxButtons; i++) {
		let newPage = Number(buttons[0].label) - 1;
		if (newPage > 0) {
			buttons.unshift({
				label: `${newPage}`, 
				href: replaceUrlParam(url, newPage)
			});
			if (buttons.length === maxButtons) break;
		}

		newPage = Number(buttons[buttons.length - 1].label) + 1;
		if (newPage < maxPages + 1) {
			buttons.push({label: `${newPage}`, href: replaceUrlParam(url, newPage)});
			if (buttons.length === maxButtons) break;
		}
	}

	// Set the first button to page 1 and the last button to last page number
	buttons[0] = {label: '1', href: replaceUrlParam(url, '1')};
	buttons[buttons.length - 1] = {label: `${maxPages}`, href: replaceUrlParam(url, maxPages)};

	// Set ellipses if button numbers are not consecutive
	if (buttons.length > 1 && maxPages > MAX_BUTTONS_MOBILE) {
		if ((buttons[1].label !== '2' && buttons[1].label !== `${currentPage}`) || (isMobile && currentPage > 2)) {
			buttons[1] = {label: `${ELLIPSES}Start`, href: undefined};
		}
		if (
			(buttons[buttons.length - 2].label !== `${maxPages - 1}` &&
				buttons[buttons.length - 2].label !== `${currentPage}`) ||
			(isMobile && currentPage < maxPages - 1)
		) {
			buttons[buttons.length - 2] = {label: `${ELLIPSES}End`, href: undefined};
		}

		const hasCurrentPage = buttons.some(({ label }) => label === `${currentPage}`);
		// Current page may have been overwritten on mobile by the ellipses, so re-insert it.
		if (isMobile && !hasCurrentPage) {
			buttons.splice(2, 0, {label: `${currentPage}`, href: replaceUrlParam(url, currentPage)});
		}
	}

	const prevPageUrl = (() => {
		if (seoUrl && seoUrl.length) {
			if (currentPage === 1) return undefined;
			return replaceUrlParam(url, currentPage - 1);
		}
		return undefined;
	})()

	const nextPageUrl = (() => {
		if (seoUrl && seoUrl.length)  {
			if (maxPages === currentPage) return undefined;
			if (maxPages > currentPage) return replaceUrlParam(url, currentPage + 1 );
			return seoUrl;
		}
		return undefined;
	})()

	return {pages: buttons, prevPageUrl, nextPageUrl};
}
